// Formats a number to a specified decimal places and removes trailing zeros
export const formatNumber = (value: string | number | undefined, decimalPlaces: number = 8): string => {
    if (value == undefined || value === '') {
        return ''
    }
    if (value === 0) {
        return '0'
    } else {
        const numValue = parseFloat(value.toString())

        if (isNaN(numValue)) {
            return ''
        }

        // Floor the number after `decimalPlaces` decimal places
        const factor = Math.pow(10, decimalPlaces)
        const roundedValue = Math.floor(numValue * factor) / factor

        // Return the fixed decimal string without converting back to number
        return roundedValue.toFixed(decimalPlaces).replace(/\.?0+$/, '')
    }
}

// Formats a fee amount with currency symbol ($ or token symbol) and handles small values (< 0.01)
export const formatFeeDisplay = (amount: number, tokenSymbol?: string) => {
    if (!tokenSymbol) {
        return +formatNumber(amount) < 0.01 ? '< $0.01' : `$${formatNumber(amount)}`
    }

    return +formatNumber(amount) < 0.01 ? `< 0.01 ${tokenSymbol}` : `${formatNumber(amount)} ${tokenSymbol}`
}

// Converts and formats large numbers (like wei) to human readable format with specified decimal places
export const formatBigNumber = (value: string | number | bigint | undefined, decimals: number = 18): string => {
    if (value == undefined || value === '') {
        return ''
    }

    if (value === 0 || value === '0') {
        return '0'
    }

    try {
        // Convert to bigint if it isn't already
        const bigValue = typeof value === 'bigint' ? value : BigInt(value.toString())

        // Convert to string and divide by 10^decimals
        const numStr = bigValue.toString()
        const wholePart = numStr.slice(0, -decimals) || '0'
        const fractionalPart = numStr.slice(-decimals).padStart(decimals, '0')

        // Combine whole and fractional parts
        const combined = `${wholePart}.${fractionalPart}`

        // Remove trailing zeros and decimal point if necessary
        return combined.replace(/\.?0+$/, '')
    } catch (error) {
        console.error('Error formatting big number:', error)
        return ''
    }
}
